import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'macAddressize',
    standalone: false
})
export class MacAddressizePipe implements PipeTransform {
  constructor() {
  }

  transform(value: string): any {
    if (!!value && value.length === 12) {
      return _.join(value.match(/.{1,2}/g), ':');
    }
    return value;
  }

}
